module.exports = __webpack_public_path__ + "img/face.9c60daee.png";